import {
  ChangeDetectionStrategy,
  Component,
  input,
  linkedSignal,
  model,
  output,
} from '@angular/core';
import { disabled, form } from '@angular/forms/signals';

@Component({
  selector: 'ups-notes',
  templateUrl: 'notes.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotesComponent {
  readonly previousNotes = input<string>();
  readonly isDisabled = input(false);
  readonly hidePreviousNotes = input(false);
  readonly hidePreviousNotesLabel = input(true);
  readonly hideNewNote = input(false);
  readonly newNote = model<string>();

  readonly newNoteChanged = output<string>();

  // done like this to keep previous behaviour. WI 35846: seeded '' (never undefined), the signal form's model;
  // disabled lives in the schema (NG8022 bans [disabled] beside [formField]).
  protected readonly newNoteInternal = linkedSignal(() => this.newNote() ?? '');
  protected readonly noteForm = form(this.newNoteInternal, (p) => {
    disabled(p, () => this.isDisabled());
  });

  constructor() {}

  onNewNoteChange() {
    this.newNoteChanged.emit(this.newNoteInternal()!);
  }
}
